/**
 * The oldest Dokploy a server may run and still be safe to hand customer
 * input to.
 *
 * Before 0.29.14 (2026-08-06) the engine built its remote-server commands by
 * string interpolation: a branch name went into `git clone --branch <here>`,
 * a scheduled job's command into `docker exec … -c '<here>'`, unquoted, in a
 * root shell over SSH. The control plane now refuses the characters that
 * would break out of those, but a customer talks to the engine through other
 * fields too, and a rule on this side is a second lock, not the first. The
 * first is the engine quoting what it runs, which is this version or later.
 *
 * Shown as a danger tag on the fleet list and the server page, not enforced:
 * an operator upgrading a fleet needs to see which box is behind, and the
 * update button is right there.
 */
export const SAFE_ENGINE_VERSION = "0.29.14";

/** Whether a sampled version is older than the safe one. Null when not reported. */
export function belowSafeVersion(version: string | null): boolean | null {
  if (!version) return null;
  const parsed = parse(version);
  if (!parsed) return null;
  return compare(parsed, parse(SAFE_ENGINE_VERSION)!) < 0;
}

function parse(version: string): number[] | null {
  const match = /^v?(\d+)\.(\d+)\.(\d+)/.exec(version.trim());
  return match ? match.slice(1, 4).map(Number) : null;
}

function compare(a: number[], b: number[]): number {
  for (let i = 0; i < 3; i += 1) {
    if (a[i]! !== b[i]!) return a[i]! - b[i]!;
  }
  return 0;
}
